import script from "./expandable-schedule-list.vue?vue&type=script&setup=true&lang=js"
export * from "./expandable-schedule-list.vue?vue&type=script&setup=true&lang=js"

import "./expandable-schedule-list.vue?vue&type=style&index=0&id=0ffcbc4a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffcbc4a"]])

export default __exports__